import { useState } from 'react';
import type { BasicHealthData } from '../../types/health';

interface OnboardingStep1Props {
  onComplete: (data: Partial<BasicHealthData>) => void;
}

export default function OnboardingStep1({ onComplete }: OnboardingStep1Props) {
  const [ageRange, setAgeRange] = useState('');
  const [sex, setSex] = useState<'male' | 'female' | 'other' | 'prefer-not-to-say'>('male');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (ageRange) {
      onComplete({ ageRange, sex });
    }
  };

  const ageRanges = ['18-24', '25-34', '35-44', '45-54', '55-64', '65-74', '75+'];

  return (
    <div className="max-w-2xl mx-auto">
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-teal-100 rounded-full mb-4">
          <i className="ri-user-heart-line text-3xl text-teal-600"></i>
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mb-3">Let's Get Started</h2>
        <p className="text-lg text-gray-600">Tell us a bit about yourself to calculate your initial Health Score</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        <div>
          <label className="block text-sm font-semibold text-gray-900 mb-4">What's your age range?</label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {ageRanges.map((range) => (
              <button
                key={range}
                type="button"
                onClick={() => setAgeRange(range)}
                className={`px-4 py-3 rounded-lg border-2 transition-all whitespace-nowrap ${
                  ageRange === range
                    ? 'border-teal-500 bg-teal-50 text-teal-700 font-semibold'
                    : 'border-gray-200 hover:border-gray-300 text-gray-700'
                }`}
              >
                {range}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-900 mb-4">Sex assigned at birth</label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { value: 'male', label: 'Male' },
              { value: 'female', label: 'Female' },
              { value: 'other', label: 'Other' },
              { value: 'prefer-not-to-say', label: 'Prefer not to say' }
            ].map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => setSex(option.value as any)}
                className={`px-4 py-3 rounded-lg border-2 transition-all whitespace-nowrap ${
                  sex === option.value
                    ? 'border-teal-500 bg-teal-50 text-teal-700 font-semibold'
                    : 'border-gray-200 hover:border-gray-300 text-gray-700'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex justify-end pt-6">
          <button
            type="submit"
            disabled={!ageRange}
            className="px-8 py-3 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
          >
            Continue
          </button>
        </div>
      </form>
    </div>
  );
}
